<template>
    <el-select v-model="selectedUser" filterable remote reserve-keyword :placeholder="placeholder"
        :remote-method="remoteMethod" :loading="loading" @change="handleChange">
        <el-option v-for="item in options" :key="item.user_id" :label="item.username" :value="item.user_id">
            <span style="float: left">{{ item.username }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.email }}</span>
        </el-option>
    </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import axios from 'axios';

export interface User {
    user_id: string;
    username: string;
    email: string;
}

export default defineComponent({
    name: 'UserSelect',
    props: {
        organizationId: {
            type: String,
            default: '',
        },
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '选择用户',
        },
    },

    emits: ['update:modelValue', 'change', 'userNameChange'],


    setup(props, { emit }) {
        const loading = ref(false);
        const options = ref<User[]>([]);
        const selectedUser = ref(props.modelValue);

        const fetchUserById = async (id: string) => {
            try {
                const response = await axios.get(`/api/users/${id}`);
                if (response.data.data) {
                    options.value = [response.data.data];
                }
            } catch (error) {
                console.error('获取用户信息失败:', error);
            }
        };

        const remoteMethod = async (query: string) => {
            if (query !== '') {
                loading.value = true;
                try {
                    const response = await axios.get('/api/users/username', {
                        params: { username: query, organization_id: props.organizationId }
                    });
                    options.value = response.data.data || [];
                } catch (error) {
                    console.error('搜索用户失败:', error);
                    options.value = [];
                } finally {
                    loading.value = false;
                }
            } else {
                options.value = [];
            }
        };

        const handleChange = (value: string) => {
            emit('update:modelValue', value);
            emit('change', value);

            // 找到选中的用户对象
            const selectedUserObj = options.value.find(
                user => user.user_id === value
            );
            // 如果找到了用户对象，发送名称
            if (selectedUserObj) {
                emit('userNameChange', selectedUserObj.username);
            }
        };

        watch(() => [props.modelValue, props.organizationId], ([newModelValue, newOrganizationId]) => {
            selectedUser.value = newModelValue;
            // 如果选择了用户，并且选项列表为空，则获取用户信息
            if (newModelValue && !options.value.some(user => user.user_id === newModelValue)) {
                fetchUserById(newModelValue);
            }
        });

        onMounted(() => {
            if (props.modelValue) {
                fetchUserById(props.modelValue);
            }
        });

        return {
            loading,
            options,
            selectedUser,
            remoteMethod,
            handleChange,
        };
    },
});
</script>